import { Link as ReactRouterLink } from 'react-router'
import { Link as ChakraLink } from '@chakra-ui/react'
import { Flex, Text } from '@chakra-ui/react'

export const FlexGroupLink = ({ id, name, sx }:
{ id?: number, name?: string, sx?: {} }) => {
  return (
    <ChakraLink as={ReactRouterLink} to={`/flex-group/${id}`} sx={sx}>
      <Flex sx={{ gap: 2, alignItems: 'center', ...sx }}>
        <Text>
          {name}
        </Text>
      </Flex>
    </ChakraLink>
  )
}